export const percentage = (dropSize:any, percent:any) => {
    percent = percent / 100;

    const total = dropSize / (1 - percent) - dropSize;

    return total.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });
}